import React from 'react';
import SEOHead from './SEOHead';

function AboutPage() {
  return (
    <div className="main-content">
      <SEOHead 
        title="About Aminole - Learn Amino Acids Through Interactive Gaming"
        description="Discover how Aminole revolutionizes biochemistry education. Learn about our mission to make amino acid learning engaging for students and teachers worldwide."
        keywords="about aminole, biochemistry education, amino acid learning, educational technology, protein structure teaching"
        url="https://aminole.net/about"
      />
      
      <div className="container" style={{ maxWidth: '800px', margin: '0 auto', padding: '40px 20px' }}>
        <h1 style={{ textAlign: 'center', marginBottom: '30px', color: '#333' }}>
          About Aminole
        </h1>
        
        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ color: '#00bcd4', marginBottom: '20px' }}>Our Mission</h2>
          <p style={{ lineHeight: '1.6', fontSize: '16px', marginBottom: '20px' }}>
            Aminole transforms the way students learn amino acids by combining the addictive gameplay of Wordle 
            with comprehensive biochemistry education. We believe learning should be engaging, interactive, and fun.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ color: '#00bcd4', marginBottom: '20px' }}>What You'll Learn</h2>
          <ul style={{ lineHeight: '1.8', fontSize: '16px' }}>
            <li><strong>Amino Acid Structures:</strong> Visual recognition of all 20 standard amino acids</li>
            <li><strong>Three-Letter Abbreviations:</strong> Master the standard biochemistry nomenclature</li>
            <li><strong>Chemical Properties:</strong> Understand polar, nonpolar, acidic, and basic classifications</li>
            <li><strong>Protein Building Blocks:</strong> Learn how amino acids form proteins</li>
          </ul>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ color: '#00bcd4', marginBottom: '20px' }}>Perfect For</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
            <div style={{ padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
              <h3 style={{ color: '#333', marginBottom: '10px' }}>Students</h3>
              <p>Studying biochemistry, molecular biology, or pre-med courses</p>
            </div>
            <div style={{ padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
              <h3 style={{ color: '#333', marginBottom: '10px' }}>Teachers</h3>
              <p>Looking for engaging ways to teach protein structure and amino acids</p>
            </div>
            <div style={{ padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
              <h3 style={{ color: '#333', marginBottom: '10px' }}>Professionals</h3>
              <p>Refreshing knowledge in biochemistry and molecular biology</p>
            </div>
          </div>
        </section>

        <section>
          <h2 style={{ color: '#00bcd4', marginBottom: '20px' }}>Get Started Today</h2>
          <p style={{ lineHeight: '1.6', fontSize: '16px', textAlign: 'center' }}>
            Ready to master amino acids? Start playing Aminole today and discover how fun biochemistry can be!
          </p>
          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <a 
              href="/game" 
              style={{
                display: 'inline-block',
                padding: '15px 30px',
                backgroundColor: '#00bcd4',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '8px',
                fontSize: '18px',
                fontWeight: 'bold'
              }}
            >
              Start Playing Now
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default AboutPage;
